import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {t} from 'shared/core';
import {FormLayout, Input, DatePicker, NumberInput, Select2, UploadFiles, ActionLink, LabelHelper, FormError} from 'shared/components';
import ActionLinks from 'main/components/tables/components/ActionLinks';
import {auth, endpoints} from 'main/tools';

const ExpenseFields = observer(({uiState, expense, errors}) => {
  const employeeId = uiState.request.employee?.id || auth.employee.id;
  return (
    <div className='p2 mb2 bg-white border rounded relative'>
      <FormLayout>
        <FormLayout.Group>
          <Input
            label='expenses.edit.Title'
            value={expense.title}
            onChange={e => expense.title = e.target.value}
            errorMessage={errors.title}
          />
          <Select2
            label='expenses.edit.Category'
            by='name'
            defaultValue={expense.nmbrPresetId}
            endpoint={endpoints.NMBR.PRESETS.with(employeeId)}
            onChange={e => uiState.updateCategory(expense, e.target.value, e.target.options[e.target.selectedIndex].text)}
            errorMessage={errors.nmbrPresetId}
          >
            <option value={expense.nmbrPresetId}>{expense.category}</option>
          </Select2>
        </FormLayout.Group>
        <FormLayout.Group>
          <DatePicker
            label='expenses.edit.Date'
            value={expense.date}
            onChange={date => expense.date = date}
            errorMessage={errors.date}
          />
          <NumberInput
            label='expenses.edit.Total'
            min={0}
            value={expense.amount}
            onChange={e => expense.amount = e.target.value}
            errorMessage={errors.amount}
            connectedLeft={
              <div className='InputGroup'>
                <span className='InputGroup-tag small'>{'$'}</span>
              </div>
            }
          />
        </FormLayout.Group>
        <Input
          label='expenses.edit.Note'
          value={expense.note}
          onChange={e => expense.note = e.target.value}
          errorMessage={errors.note}
        />
        <div>
          <LabelHelper label={t('expenses.edit.Receipts')}/>
          <UploadFiles
            defaultFiles={expense.receipts}
            onChange={files => expense.receipts.replace(files)}
            modelType='expenses/receipt'
          />
        </div>
      </FormLayout>
      <div className='absolute top-0 right-0 p1'>
        <ActionLinks
          model={expense}
          onlyShowCustomLinks
          customLinks={[{
            order: 0,
            text: 'expenses.edit.Remove',
            action: () => uiState.removeExpense(expense)
          }]}
        />
      </div>
    </div>
  );
});

const ExpenseList = observer(({uiState}) => {
  const {request, errors} = uiState;

  return (
    <React.Fragment>
      {request.expenses.map((expense, index) => (
        <ExpenseFields
          key={index}
          uiState={uiState}
          expense={expense}
          errors={_.get(errors, `expenses[${index}]`, {})}
        />
      ))}
      <ActionLink className='TextLink dodger inline-block mb2' onClick={() => uiState.addExpense()}>
        <FormattedMessage id='expenses.edit.+ Add expense'/>
      </ActionLink>
      <FormError message={errors.expenses}/>
    </React.Fragment>
  );
});

export default ExpenseList;
